import { ArticleInfo } from "../entities/ArticleInfo";
import { DocumentInfo } from "../entities/DocumentInfo";
import { MovieInfo } from "../entities/MovieInfo";
import { LiveInfo } from "../entities/LiveInfo";

// 自身がこのコンテンツのオーナー(講師)かどうか
export const isOwnerContent = (content?: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => {
  if (!content) {
    return false;
  }
  return content.isOwner;
};

// 契約済みか
export const isContractContent = (content?: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => {
  if (!content) {
    return false;
  }
  if (content.isContract) {
    return isContractPlan(content.plan);
  }
  return false;
};

// 仮解約中か
export const isProvisionalCancellationContent = (content?: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => {
  if (!content) {
    return false;
  }
  if (content.isContract) {
    switch (content.plan?.contractStatus.contractStatusCode) {
      case "provisional_cancellation":
        return true;
    }
  }
  return false;
};

// コンテンツを見ることができるかどうか
export const isShowableContent = (content?: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => {
  if (!content) {
    return false;
  }

  if (isOwnerContent(content)) {
    return true;
  }

  if (content.publishStatus === "PRIVATE") {
    return false;
  }

  if (content.isFree) {
    return true;
  }

  if (isContractContent(content)) {
    return true;
  }
  return false;
};

// ダウンロード可能か
export const isDownloadableContent = (content?: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => {
  if (!content) {
    return false;
  }
  if (content.contentsType === "document") {
    return content.plan?.isDownloadableDocument ?? false;
  } else if (content?.contentsType === "movie" || content?.contentsType === "archive_movie") {
    return content.plan?.isDownloadableVideo ?? false;
  }
  return false;
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    isOwnerContent: (content: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => boolean;
    isContractContent: (content: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => boolean;
    isShowableContent: (content: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => boolean;
    isProvisionalCancellationContent: (content: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => boolean;
    isDownloadableContent: (content: ArticleInfo | DocumentInfo | MovieInfo | LiveInfo) => boolean;
  }
}
